<template>
  <textarea v-model="model" data-test-id="base-textarea" />
</template>

<script lang="ts" setup>
const model = defineModel<string>()
</script>
